interface Config {
    firebase: {
        apiKey: string;
        authDomain: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
    };
    app: {
        baseURL: string;
        apiURL: string;
        clientBaseURL: string;
    };
}

const prod: Config = {
    firebase: {
        apiKey: "AIzaSyCbOqjIlay6AS9qzwUgLZqD8k3BaQ8VP9c",
        authDomain: "video-note-338718.firebaseapp.com",
        projectId: "video-note-338718",
        storageBucket: "video-note-338718.appspot.com",
        messagingSenderId: "40997510190",
        appId: "1:40997510190:web:e4f81d0a3c63a7242313bf",
    },

    app: {
        baseURL: "https://vidnote-api.herokuapp.com",
        apiURL: "/v1/api",
        clientBaseURL: "https://vidnote.web.app",
    },
};

// const local = "http://10.0.0.101"
const local = "http://localhost";

const dev: Config = {
    firebase: {
        apiKey: "AIzaSyCbOqjIlay6AS9qzwUgLZqD8k3BaQ8VP9c",
        authDomain: "video-note-338718.firebaseapp.com",
        projectId: "video-note-338718",
        storageBucket: "video-note-338718.appspot.com",
        messagingSenderId: "40997510190",
        appId: "1:40997510190:web:e4f81d0a3c63a7242313bf",
    },
    app: {
        baseURL: `${local}:8080`,
        apiURL: "/v1/api",
        clientBaseURL: `${local}:3000`,
    },
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;

// export const config = prod;
